import {RouterView} from "vue-router";

const routes = [
        {
            path: "",
            name: "home",
            // route level code-splitting
            // this generates a separate chunk (HomePage.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import("@/views/pages/homepage/index.vue"),
        },
    {
        path: "about-us",
        name: "about-us",
        component: () => import("@/views/pages/about-us/index.vue"),
        // component: () => import("../views/pages/about-us/AboutUsPage.vue"),
    },
    {
        path: "opportunities",
        name: "opportunities",
        component: () =>
            import("../views/pages/opportunities/index.vue"),
    },
    {
        path: "opportunities/:slug",
        name: "opportunities.show",
        props: true,
        component: () =>
            import("../views/pages/opportunities/OpportunityPage.vue"),
    },
    {
        path: "unsubscribe/:email",
        name: "unsubscribe",
        props: true,
        component: () =>
            import("../views/pages/UnsubscribePage.vue"),
    },
        {
            path: "customer",
            name: "customer",
            component: () =>
                import("../views/layouts/CustomerLayout.vue"),
            meta: { requiresAuth: true },
            children: [
                {
                    path: "overview",
                    name: "customer.overview",
                    component: () =>
                        import("../views/pages/customer/overview/OverviewPage.vue"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "investments",
                    name: "customer.investments",
                    component: () =>
                        import(
                            "../views/pages/customer/investments/InvestmentPage.vue"
                            ),
                    meta: { requiresAuth: true },
                },
                {
                    path: "documents",
                    name: "customer.documents",
                    component: () =>
                        import("../views/pages/customer/documents/DocumentsPage.vue"),
                    meta: { requiresAuth: true },
                },
                {
                    path: "tax-reports",
                    name: "customer.tax-reports",
                    component: () =>
                        import(
                            "../views/pages/customer/tax-reports/TaxReportsPage.vue"
                            ),
                    meta: { requiresAuth: true },
                },
                {
                    path: "manage-account",
                    name: "customer.manage-account",
                    component: () =>
                        import(
                            "../views/pages/customer/manage-account/ManageAccountPage.vue"
                            ),
                    redirect: {
                        name: "customer.manage-account.personal-information",
                    },
                    meta: { requiresAuth: true },
                    children: [
                        {
                            path: "personal-information",
                            name: "customer.manage-account.personal-information",
                            component: () =>
                                import(
                                    "../views/pages/customer/manage-account/components/PersonalInformationComponent.vue"
                                    ),
                            meta: { requiresAuth: true },
                        },
                        // {
                        //     path: "personal-address",
                        //     name: "customer.manage-account.personal-address",
                        //     component: () =>
                        //         import(
                        //             "../views/pages/customer/manage-account/components/PersonalAddressComponent.vue"
                        //             ),
                        //     meta: { requiresAuth: true },
                        // },
                        {
                            path: "kyc",
                            name: "customer.manage-account.kyc",
                            component: () =>
                                import(
                                    "../views/pages/customer/manage-account/components/KYCComponent.vue"
                                    ),
                            meta: { requiresAuth: true },
                        },
                        {
                            path: "security",
                            name: "customer.manage-account.security",
                            component: () =>
                                import(
                                    "../views/pages/customer/manage-account/components/SecurityComponent.vue"
                                    ),
                            meta: { requiresAuth: true },
                        },
                    ],
                },
            ],
        },
    ];

/*
routes.push({
    // path: ":catchAll(.*)",
    path: ":pathMatch(.*)*",
    // path: "404",
    component: () => import("@/pages/not-found/NotFound.vue"),
    name: "not-found",
});
*/

export default [{
    path: "/",
    // path: "/:locale?",
    component: RouterView,
    // redirect: {name: 'home'},
    children: routes
}];